const kbaPrefix = 'KBA_ISSUING';

export const GET_SET_KBA_PAGE_START = `${kbaPrefix}/GET_SET_KBA_PAGE_START`;
export const GET_SET_KBA_PAGE_SUCCESS = `${kbaPrefix}/GET_SET_KBA_PAGE_SUCCESS`;
export const GET_SET_KBA_PAGE_FAIL = `${kbaPrefix}/GET_SET_KBA_PAGE_FAIL`;

export const SET_KBA_START = `${kbaPrefix}/SET_KBA_START`;
export const SET_KBA_SUCCESS = `${kbaPrefix}/SET_KBA_SUCCESS`;
export const SET_KBA_FAIL = `${kbaPrefix}/SET_KBA_FAIL`;
